import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess,
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile } from "../../../helpers/utils/FileUtils";

export const appraisalRollsApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchAppraisalRolls: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/appraisal-rolls?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['appraisalRolls'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

     

        getAppraisalRollById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-appraisal-roll-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['countyById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportAppraisalRollsData: build.query({
            query: (query) => {
                return {
                    url: `/export/appraisal-roll`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("appraisal rolls"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getPrimaryCollectorByStateAndCounty: build.query({
            query: ({ stateAbbr, countyName }) => {
                let paramData = serialize({ stateAbbr: stateAbbr, countyName: countyName })
                return {
                    url: `/ajax/primary-collector-by-state-county?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['getPrimaryCollectorByStateAndCounty'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),
});


export const {
    useGetAppraisalRollByIdQuery,
    useSearchAppraisalRollsQuery,
    useGetPrimaryCollectorByStateAndCountyQuery,
    useLazyExportAppraisalRollsDataQuery,
} = appraisalRollsApi;